import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import "../assets/css/prefooter.css";

const Prefooter = () => {
  return (
    <div className="container prefooter-container">
      <Row className="prefooter-row">
        {/* First part: Title */}
        <Col xs={12} md={6} className="prefooter-title">
          <p className="title-content">
            Meet Complex Cybersecurity Management and Regulations with ViXa
            Platform
          </p>
        </Col>

        {/* Second part: Comment and buttons */}
        <Col xs={12} md={6} className="prefooter-content">
          <div className="prefooter-comment">
            <p className="comment-content">
              Companies need to ensure the confidentiality, integrity, and
              accessibility of all their critical systems and data at all times.
              A security partner such as Ost Infinity can help you keep valuable
              customer and financial data away from the hands of cyber
              criminals, as well as ensure business continuity. We also assist
              you in navigating various laws and regulations regarding data
              protection, such as GDPR, so that you remain compliant.
            </p>
          </div>
          <div className="prefooter-buttons">
            <Row className="prefooter-buttons-align">
              <Col xs={6}>
                <Button className="custom-buttons" block="true">
                  Button 1
                </Button>
              </Col>
              <Col xs={6}>
                <Button className="custom-buttons" block="true">
                  Button 2
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Prefooter;
